// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"f076d8ea","684":"0b70b898","888":"d0ac1739","908":"81f21b53"}[chunkId] + ".chunk.js";
};